/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import CardHeader from '../../components/CardHeader';
import Topbar from './components/Topbar';
import { dataService } from '../../services/data.services';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import Table from './components/Table';
import Pagination from '../../components/Pagination';
import GlobalContext from '../../components/Context/GlobalContext';
import Modalcustom from '../../components/CustomModal';
import SmsModal from './components/SmsModal.';
import EmailModal from './components/EmailModal';
import { authHeader } from '../../CommonMethods/Auth-Headers';
const ManageCustomers = () => {
    const initialDate = {
        start_date: '',
        end_date: '',
    }
    const initialDateError = {
        start_date: '',
        end_date: '',
    }
    const { setToastmessage, setToastError } = useContext(GlobalContext);
    const [DateRange, SetDateRange] = useState(initialDate);
    const [DateRangeError, SetDateRangeError] = useState(initialDateError)
    const [customerList, setCustomerList] = useState();
    const [searchParams, setSearchParams] = useSearchParams({});
    const [SearchValue, setSearchValue] = useState('');
    const [notFound, setNotFound] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false)
    const [exportLoading, setExportLoading] = useState(false);
    const [sendSms, setSendSms] = useState(false)
    const [customers, setCustomers] = useState();
    const [smsList, setSmsList] = useState([]);
    const [smsModal, setSmsModal] = useState(false)
    const [note, setNote] = useState('');
    const [noteError, setNoteError] = useState('');
    const [noteFocus, setNoteFocus] = useState(false);
    const [sendLoading, setSendLoading] = useState(false) 
    const [sendEmail, setSendEmail] = useState(false)
    const [emailList, setEmailList] = useState([]);
    const [emailModal, setEmailModal] = useState(false)
    const [subject, setSubject] = useState('');
    const [subjectError, setSubjectError] = useState('');
    const [subjectFocus, setSubjectFocus] = useState(false);
    const [bodyContent, setBodyContent] = useState('');
    const [bodyError, setBodyError] = useState('');
    const [bodyFocus, setBodyFocus] = useState(false);
    

    const getCustomer = useCallback(async () => {
        setLoading(true);
        setNotFound(false)
        try {
            let response = await dataService.GetAPI(`customer-users/list?${new URLSearchParams(searchParams).toString()}`);
            setCustomerList(response?.data);
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setNotFound(true);
        }

    }, [searchParams])

    const handleSearchParams = (key, value, del) => {
        let params = Object.fromEntries(searchParams);
        if (del) {
            delete params[del]
        } else {
            params.page_number = 1
            if (key === 'search') params[key] = encodeURIComponent(value)
            else params[key] = value
            if (params.search === '') delete params.search
        }
        setSearchParams({ ...params })
    }
    const handleSetDate = (key, value) => {
        SetDateRangeError(initialDateError)
        const dateCopy = { ...DateRange }
        dateCopy[key] = value;
        SetDateRange(dateCopy)
    }
    const handleDatePickerValidation = () => {
        let error = []
        const errorState = { ...DateRangeError }
        Object.keys(DateRangeError).map((item) => {
            switch (true) {
            case item === 'start_date' && DateRange['end_date'] === '':
                if (DateRange[item] !== '' && DateRange['end_date'] === '') {
                    errorState['end_date'] = 'End date is required'
                    error.push(item)

                }
                break

            case item === 'end_date' && DateRange['start_date'] === '':
                if (DateRange[item] !== '' && DateRange['start_date'] === '') {
                    errorState['start_date'] = 'Start date is required'
                    error.push(item)

                }
                break
            case DateRange['start_date'] !== '' && DateRange['end_date'] !== '':

                if ((DateRange['start_date'] !== '' && DateRange['end_date'] !== '') && !moment(DateRange['start_date']).isSameOrBefore(moment(DateRange['end_date']))) {
                    errorState['start_date'] = 'End date should be greater than start date'
                    error.push(item)

                }
            }
        })
        SetDateRangeError(errorState)
        return error.length > 0
    }
    const handleApplyFilter = (clear) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if (clear) {
            if (!(params?.start_date || params?.end_date)) {
                return;
            }
            SetDateRange(initialDate);
            SetDateRangeError(initialDateError)
            delete params.start_date;
            delete params.end_date;
            setSearchParams({ ...params })
            return
        }
        if (DateRange['start_date'] !== '' && DateRange['end_date'] !== '') {
            params.start_date = moment(DateRange['start_date']).unix()
            params.end_date = moment(DateRange['end_date']).unix()
        }
        // if(status === '') {
        //     delete params.status;
        //     setSearchParams(params);
        // } else {
        //     params.status = status;
        //     getSearchParamDetail(searchParams, setSearchParams, {status: status})
        // }
        SetDateRangeError(initialDateError)
        setSearchParams({ ...params })
    }
    useEffect(() => {
        let params = Object.fromEntries(searchParams);
        if (!params.page_number) {
            params['page_number'] = 1;
        }
        const copyDate = { ...DateRange }
        if ((params['start_date'] && params['end_date']) && params['start_date'] !== '' && params['end_date'] !== '') {
            copyDate.start_date = new Date(params['start_date'] * 1000)
            copyDate.end_date = new Date(params['end_date'] * 1000)
        }
        if (params.hasOwnProperty('search')) {
            setSearchValue(decodeURIComponent(params.search));
        }
        SetDateRange(copyDate)
        setSearchParams(params);
        getCustomer();
    }, [getCustomer])

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    const handleExport = async () => {
        let params = Object.fromEntries(searchParams);
        delete params.page_number;
        try {
            setExportLoading(true);
            const res = await dataService.GetAPI(`customer-users/export-csv?${new URLSearchParams(params).toString()}`)
            if (!res.error) {
                window.open(
                    res.data.url,
                    '_blank'
                );
                setExportLoading(false)
                setToastmessage('Customer list exported successfully');

            }
        } catch (error) {
            setToastError('An Error Occured!');
            setExportLoading(false);
        }
    }
    const handleCheckbox = (key) => {
        let array = [...smsList];

        if (key === 'select_all_page') {
            customerList?.data?.forEach(item => {
                if (!array.includes(item._id)) {
                    array.push(item._id);
                }
            });
        } else if (key === 'delete') {
            customerList?.data?.forEach(item => {
                array = array.filter(id => id !== item._id);
            });
        }

        setSmsList(array);
    }
    useEffect(() => {
        setCustomers('')
    }, [searchParams])

    const handleClose = () => {
        setSmsModal(false);
        setNote('')
        setNoteError(false);
        setNoteFocus(false);
    }
    const handleSubmit = async () => {
        if (note.trim().length > 250) {
            setNoteError('Description too long. Max 250 characters.');
            return;
        } else if (note.trim().length == 0) {
            setNoteError('This field is mandatory');
            return;
        }
        let body = {}
        console.log('====================================');
        console.log(customers , "dddddddd");
        console.log('====================================');
        if (customers === 'select_all') {
            body['customer_ids'] = 'all_customers';
            body['message'] = note.trim();
        } else {
            body['customer_ids'] = smsList;
            body['message'] = note.trim();
        }
        try {
            setSendLoading(true)
            let params = Object.fromEntries(searchParams);
            delete params['sort'];
            delete params['page_number'];
            let response = await dataService.PostAPI(body, `customer-users/sms-from-admin?${new URLSearchParams(params).toString()}`);
            if (!response?.error) {
                setToastmessage(response?.data?.message);
                setSmsModal(false);
                setNote('')
                setNoteError(false);
                setNoteFocus(false);
                setSmsList([]);
                setCustomers('');
                setSendSms(false);
            }
            setSendLoading(false);
        } catch (error) {
            console.log(error, 'errrr')
            setToastError('An error occured')
            setSendLoading(false);
        }
    }






    const handleEmailSubmit = async () => {
        const API_HEADERS = await authHeader()
        console.log('here')
        // Validate subject
        if (subject.trim().length === 0) {
            setSubjectError('Subject is required');
            return;
        }
        if (subject.trim().length > 200) {
            setSubjectError('Subject must be 200 characters or less');
            return;
        }

        // Validate body content
        if (bodyContent.trim().length === 0) {
            setBodyError('Email content is required');
            return;
        }
        if (bodyContent.trim().length > 2000) {
            setBodyError('Email content must be 2000 characters or less');
            return;
        }

        // Prepare body
        let body = {
            subject: subject.trim(),
            email_content: bodyContent.trim()
        };

        console.log(customers, 'customers');
        
        // Determine customer IDs
        if (customers === 'select_all') {
            body['customer_ids'] = 'all_customers';
        } else {
            // Ensure only selected customers are included
            if (emailList && emailList.length > 0) {
                body['customer_ids'] = emailList;
            } else if (smsList && smsList.length > 0) {
                // Fallback to smsList if emailList is empty
                body['customer_ids'] = smsList;
            } else {
                // No customers selected
                setToastError('Please select customers to send email');
                return;
            }
        }

        console.log('====================================');
        console.log(API_HEADERS);
        console.log('====================================');

        try {
            setSendLoading(true)
            let params = Object.fromEntries(searchParams);
            delete params['sort'];
            delete params['page_number'];

            const queryString = new URLSearchParams(params).toString();
            let endpoint = `customer-users/email-from-admin${queryString ? `?${queryString}` : ''}`
            const response = await dataService.PostAPI(body, endpoint);
            // const responseData = await response.json();
            console.log(response, 'sushmitha')
            if (!response.error) {
                // Success handling
                setToastmessage(response.message || 'Email sending initiated successfully. This might take a while.');
                
                // Reset states
                setEmailModal(false);
                setSubject('');
                setBodyContent('');
            
                
                setEmailList([]);
                setSmsList([]);  
                setCustomers('');  
                setSendEmail(false);
                
            } else {
                // Error handling
                setToastError(response.message || 'Failed to send emails');
            }
        } catch (error) {
            console.error('Email sending error:', error);
            setToastError('An error occurred while sending emails');
        } finally {
            setSendLoading(false);
        }
    }
    const handleEmailClose = () => {
        setEmailModal(false);
        setSubject('');
        setBodyContent('');
        setSubjectError('');
        setBodyError('');
        setSubjectFocus(false);
        setBodyFocus(false);
    }












    //dont remove
    const param = Object.fromEntries(searchParams);
    return (
        <>
            <CardHeader header={'Customers'} noIcon>
                <div className="bg-[#f5f5f5] px-[15px] pt-[14px] pb-[14px] mt-[110px] userHeight">
                    <div className=' bg-white h-customh10 p-6'>
                        <Topbar
                            Title={'Customer List'}
                            tooltip={'Send Email'}
                            DateRange={DateRange}
                            DateRangeError={DateRangeError}
                            SetDateRangeError={SetDateRangeError}
                            customerList={customerList}
                            handleApplyFilter={handleApplyFilter}
                            handleDatePickerValidation={handleDatePickerValidation}
                            handleSetDate={handleSetDate}
                            DateErrorClear={() => SetDateRangeError(initialDateError)}
                            SearchValue={SearchValue}
                            setSearchValue={setSearchValue}
                            handleOnClickSearch={handleSearchParams}
                            List={customerList}
                            handleClick={handleExport}
                            exportLoading={exportLoading}
                            sendSms={sendSms}
                            setSendSms={setSendSms}
                            customers={customers}
                            setCustomers={setCustomers}
                            smsList={smsList}
                            setSmsList={setSmsList}
                            setSmsModal={setEmailModal}
                            sendEmail={sendEmail}
                            setSendEmail={setSendEmail}
                            
                            emailList={emailList}
                            setEmailList={setEmailList}
                            setEmailModal={setEmailModal}

                            // setEmailModal={() => {
                            //     console.log('Opening Email Modal');  // Debugging
                            //     setEmailModal(true);
                            // }}  // Ensure modal is opening
                        />
                        {(customers === 'select_all_page' || customers === 'select_all') && (
                            <div className='border border-[#EB9DC7] py-2 mt-4 flex justify-center items-center gap-4'>
                                {customers === 'select_all_page' && (
                                    <p className='font-normal text-xs text-[#000000]'>
                                        {`All ${customerList?.data?.length} customers on this page are selected.`}
                                    </p>
                                )}
                                <p 
                                    className={`${customers === 'select_all' ? 'text-[#000000]' : 'text-[#9E2064] cursor-pointer'} text-xs`} 
                                    onClick={() => setCustomers('select_all')}
                                >
                                    {`${customers === 'select_all_page' 
                                        ? `Select all ${customerList?.total_count} customers` 
                                        : `All ${customerList?.total_count} customers are selected`}`}
                                </p>
                            </div>
                        )}
                        <div className='bg-white h-fit rounded-b'>
                            <Table
                                List={customerList}
                                notFound={notFound}
                                error={error}
                                loading={loading}
                                searchParams={searchParams}
                                handleSearchParams={handleSearchParams}
                                DateRange={DateRange}
                                initialDate={initialDate}
                                sendSms={sendSms}
                                setSendSms={setSendSms}
                                customers={customers}
                                setCustomers={setCustomers}
                                handleCheckbox={handleCheckbox}
                                smsList={smsList}
                                setSmsList={setSmsList}
                            />
                        </div>
                        {!loading && Math.ceil(customerList?.total_count / 10) > 1 && (!(customerList?.data?.length === 0 && !(param.start_date || param.end_date))) &&
                            <Pagination smsList={smsList} customers={customers} selection={sendSms} selectedPageNumber={searchParams.get('page_number')} handleOnClickPageNumber={handleOnClickPageNumber} TotalCount={customerList?.total_count} totalPageNumber={Math.ceil(customerList?.total_count / 10)} />}
                    </div>
                </div>

                {/* <Modal open={Object.keys(modalpopup).length > 0} onClose={handleClose}>
                    <Confirmationpopup
                        message={`Are you sure you want to ${modalpopup.status === true ? 'Deactivate' : 'Activate'} the admin user ${modalpopup.name}? `}
                        Title={`${modalpopup.status === true ? 'Deactivate' : 'Activate'} Admin User`}
                        handleSubmit={handleActivate}
                        stateKey={`${modalpopup.status === true ? 'Deactivate' : 'Activate'}`}
                        loading={activateLoading}
                        handleClose={handleClose} />

                </Modal> */}
                {/* <Modalcustom open={smsModal} container={'h-fit mt-[60px]'} onClose={handleClose}>
                    <SmsModal
                        handleSubmit={handleSubmit}
                        noteFocus={noteFocus}
                        setNoteFocus={setNoteFocus}
                        note={note}
                        setNote={setNote}
                        noteError={noteError}
                        setNoteError={setNoteError}
                        loading={sendLoading}
                        handleClose={handleClose}
                    />
                </Modalcustom> */}
                <Modalcustom open={emailModal} container={'h-fit mt-[60px]'} onClose={handleEmailClose}>
                    <EmailModal
                        handleSubmit={handleEmailSubmit}
                        loading={sendLoading}
                        handleClose={handleEmailClose}
                        bodyFocus={bodyFocus}
                        setBodyFocus={setBodyFocus}
                        subjectFocus={subjectFocus}
                        setSubjectFocus={setSubjectFocus}
                        bodyContent={bodyContent}
                        subject={subject}
                        setSubject={setSubject}
                        subjectError={subjectError}
                        setSubjectError={setSubjectError}
                        setBody={setBodyContent}
                        bodyError={bodyError}
                        setBodyError={setBodyError}
                        
                    />
                </Modalcustom>
            </CardHeader>

        </>
    );
}

export default ManageCustomers;
